export type ModelConfig = {
  yolo: string;
  objects: string[];
  confidence: number;
};

export type WorkerConfig = {
  id: string;
  model: string;
  historySize: number;
  confidence: number;
};

export type BoxesResponse = {
  objectIndex: number;
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
  confidence: number;
};

export type RegressionResponse = number[];
